<template>
    <div class="fluid">
        <h1 class="app-title">Carga Refis</h1>
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col class="text-right">
                    <b-button class="ml-2 my-2" variant="secondary" @click="limparFiltros"
                              style="margin-right: 10px; height: 40px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="col-2" style="height: 40px;"></b-form-select>
                </b-col>
            </b-row>

            <b-table :items="items"
                     :fields="fields"
                     striped
                     small
                     responsive="sm"
                     :busy="configTable.load"
                     show-empty
                     hover
                     bordered
                     class="mb-0"
                     head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhum arquivo encontrado.</p>
                </template>
                <template v-slot:head(selecionar)="{ item }">
                    <b-form-checkbox v-model="configTable.checkedAll" class="coluna-fixa justify-content-center text-center" @change="toggleAll" />
                </template>
                <template v-slot:cell(selecionar)="{ item }">
                    <b-form-checkbox class="coluna-resize mx-auto justify-content-center text-center" style="z-index: 0" :checked="selecteds.includes(item)" @change="toggleCheck($event, item)" />
                </template>
                <template v-slot:head(1)="{ item }">
                    Arquivo <i class="coluna-fixa filter" :class="!isEmpty(filtros.arquivo) || filtros.filtrarArquivo == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('arquivo', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(1)="{ item }">
                    <p class="coluna-resize">
                        {{ item.arquivo }}
                    </p>
                </template>
                <template v-slot:head(2)="{ item }">
                    Data da Disponibilização pela SEFA <i class="coluna-fixa filter" :class="!isEmpty(filtros.data) || filtros.filtrarData == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('data', 'data', '', null, $event)"></i>
                </template>
                <template v-slot:cell(2)="{ item }">
                    <p class="coluna-resize text-center">
                        {{ item.data }}
                    </p>
                </template>
            </b-table>

            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Arquivos Encontrados:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Arquivos Selecionados:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" @click="download" :disabled="selecteds.length == 0">
                                <i class="fas fa-download"></i> Download
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-card>
        <CompLoading ref="loading"/>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>
<script>
    import axios from 'axios'
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';
    import CompLoading from "../shared/components/CompLoading";

    export default {
        components: {CompFiltroGrid, CompBotaoExibirOcultarColuna, CompLoading},
        mixins: [ formatarMixins ],
        watch: {
            currentPage() {
                this.configTable.checkedAll = false;
                this.consultar();
            },
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        data() {
            return {
                urlApi: null,
                token: null,
                value: null,
                options: [
                    {name: 'ICMS', code: 'av'},
                    {name: 'ITCMD', code: 'pa'}
                ],
                indice: null,
                fields: [
                    {
                        key: "selecionar",
                    }
                ],
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'dossie.coddossietrp',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                selecteds: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    arquivo: null,
                    filtrarArquivo: null,
                    data: null,
                    filtrarData: null,
                }
            }
        },
        computed: {
            currentPage() {
                return this.configTable.currentPage;
            },
            perPage() {
                return this.configTable.perPage;
            },
            getTheme () {
                return this.$store.getters.getTheme
            },
        },
        methods: {
            toggleAll(checked) {
                if(checked) {
                    this.items.forEach(el => {
                        if(!this.selecteds.includes(el)) {
                            this.selecteds.push(el);
                        }
                    })
                } else {
                    this.items.forEach(el => {
                        if(this.selecteds.includes(el)) {
                            const index = this.selecteds.indexOf(el);
                            this.selecteds.splice(index, 1);
                        }
                    })
                }
            },
            toggleCheck(checked, item) {
                if(checked) {
                    this.selecteds.push(item);
                } else {
                    const index = this.selecteds.indexOf(item);
                    this.selecteds.splice(index, 1);
                    this.configTable.checkedAll = false;
                }
            },
            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/refis/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'cargaRefis';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'arquivo') {
                        this.filtro.filtrarEm = this.filtros.filtrarArquivo;
                        this.filtro.campoTexto = this.filtros.arquivo;
                    } else if(this.filtro.campoFiltro == 'data') {
                        this.filtro.filtrarEm = this.filtros.filtrarData;
                        this.filtro.campoData = this.filtros.data;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoFiltro == 'arquivo') {
                    this.filtros.filtrarArquivo = this.filtro.filtrarEm;
                    this.filtros.arquivo = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'data') {
                    this.filtros.filtrarData = this.filtro.filtrarEm;
                    this.filtros.data = this.filtro.campoData;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                this.configTable.sortField = this.filtro.campoFiltro;

                this.configTable.sortOrder = order;

                this.consultar();
            },

            limparFiltros() {
                this.filtros = {
                    arquivo: null,
                    filtrarArquivo: null,
                    data: null,
                    filtrarData: null,
                };

                this.consultar();
            },

            async download() {
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/refis/downloadArquivo`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        let blob = new Blob([response.data], {type: "octet/stream"});
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = this.selecteds.length == 1 ? this.selecteds[0].arquivo : 'arquivos_refis.zip';
                        link.click();
                    }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            this.obterColunasUsuario();
            this.consultar();
        }
    }
</script>
